// extracted by mini-css-extract-plugin
export default {"scrollbar":"scrollbar_scrollbar__+I2Pi"};